import React from 'react';
import {
  ActivityIndicator
} from 'react-native';
import PropTypes from 'prop-types';
import { Button } from './Button';
import Colors from "../../constants/Colors";

const ButtonWithSpinner = ({ isLoading, size, ...rest }) => {

  if (isLoading) {
    return (
      <ActivityIndicator size={size || 'large'} color={Colors.spinnerColor} />
    )
  }

  return <Button {...rest} />
};

ButtonWithSpinner.propTypes = {
  text: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export { ButtonWithSpinner };
